
import React, { useMemo } from "react";

import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

// Define a default UI for filtering
export function DefaultColumnFilter({ columnFilterValue, setIsFiltered, column }) {
  return (
    <TextField
      value={columnFilterValue || ''}
      onChange={(e) => {
        setIsFiltered(e.target.value);
        column.setFilterValue(e.target.value || ''); // Set undefined to remove the filter entirely
      }}
      sx={{
        m: 1,
        minWidth: 120,
        fontSize: 12,
        height: 24,
        maxHeight: 24,
        minHeight: 24,
        color: "var(--table-th-text",
      }}
      variant="standard"
      placeholder={`Search ...`}
    />
  );
}

// This is a custom filter UI for selecting
// a unique option from a list
export function SelectColumnFilter({ table, columnFilterValue, setIsFiltered, column }) {
  const columnId = column.id 

  const uniqueValues = useMemo(() => {
    const values = table.getCoreRowModel().flatRows.map(row => row.getValue(columnId))
    return Array.from(new Set(values));
  }, [table, columnId]);

  return (
    <Select
      MenuProps={{
        disablePortal: true
      }}
      value={columnFilterValue || ''}
      onChange={(e) => {
        setIsFiltered(e.target.value);
        column.setFilterValue(e.target.value || '');
      }}
      sx={{
        m: 1,
        minWidth: 120,
        fontSize: 12,
        height: 24,
        maxHeight: 24,
        minHeight: 24,
        backgroundColor: "var(--nhub-color-background-1)",
      }}
      variant="outlined"
      autoWidth
      data-testid='selectColumnFilter-input'
    >
      <MenuItem value='' sx={{ fontSize: 12 }}>
        <em>All</em>
      </MenuItem>
      {Array.from(uniqueValues).map((option, i) => (
        <MenuItem key={i} value={option} sx={{ fontSize: 12 }} >
          <em>{option}</em>
        </MenuItem>
      ))}
    </Select>
  );
}